import { render, staticRenderFns } from "./Quotation.vue?vue&type=template&id=39fb63ca&scoped=true"
import script from "./Quotation.vue?vue&type=script&lang=js"
export * from "./Quotation.vue?vue&type=script&lang=js"
import style0 from "./Quotation.vue?vue&type=style&index=0&id=39fb63ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39fb63ca",
  null
  
)

export default component.exports